<template>
  <div class="q-pa-xs">
    <q-tabs
        v-model="tab"
        align="justify"
        inline-label
    >
      <q-tab v-if="$auth.can('users.list')" class="bg-white text-input-color" name="info" icon="fas fa-id-card" label="Profile"/>
      <q-tab v-if="$auth.can('users.orders')" class="bg-white text-input-color" name="orders" icon="fas fa-history" label="Orders History"/>
      <q-tab v-if="$auth.can('recipients.list')" class="bg-white text-input-color" name="recipients" icon="fas fa-users" label="Recipients"/>
      <q-tab v-if="$auth.can('users.referrals_info')" class="bg-white text-input-color" name="referrals" icon="fas fa-people-arrows" label="Referrals"/>
      <q-tab v-if="$auth.can('notifications.list')" class="bg-white text-input-color" name="notifications" icon="fas fa-envelope" label="Notifications"/>
      <q-tab v-if="$auth.can('transfer-limits.list')" class="bg-white text-input-color" name="transfer_limits" icon="fas fa-hands-holding-circle" label="Transfer limits"/>
    </q-tabs>

    <q-separator/>

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel v-if="$auth.can('users.list')" name="info" class="bg-lime-1">
        <user-info :user="user"/>
      </q-tab-panel>
      <q-tab-panel v-if="$auth.can('users.orders')" name="orders" class="bg-lime-1">
        <user-orders :user="user"/>
      </q-tab-panel>
      <q-tab-panel v-if="$auth.can('recipients.list')" name="recipients" class="bg-lime-1">
        <recipients-list :user="user" />
      </q-tab-panel>
      <q-tab-panel v-if="$auth.can('users.referrals_info')" name="referrals" class="bg-lime-1">
        <users-list :user="user"/>
        <user-rewards :user="user"/>
      </q-tab-panel>
      <q-tab-panel v-if="$auth.can('notifications.list')" name="notifications" class="bg-lime-1">
        <notification-list :user="user"/>
      </q-tab-panel>
      <q-tab-panel v-if="$auth.can('transfer-limits.list')" name="transfer_limits" class="bg-lime-1">
        <transfer-limits :user="user"/>
      </q-tab-panel>
    </q-tab-panels>
  </div>
</template>

<script>
import UserInfo from 'Modules/User/resources/pages/details/UserInfo.vue'
import UserOrders from 'Modules/Transfer/resources/pages/Index.vue'
import RecipientsList from 'Modules/Recipient/resources/pages/Index.vue'
import NotificationList from 'Modules/Notification/resources/pages/Index.vue'
import TransferLimits from 'Modules/Ramp/resources/components/TransferLimits.vue'
import UserRewards from "./UserRewards.vue"

export default {
    name: "UserDetails",
    props: {
      user: {
        type: Object,
        required: true
      }
    },
    computed: {},
    data() {
      return {
        tab: 'info',
        rewards: {
          cash_earned: 0,
          savings_to_date: [],
          total_signed_up_friends: 0,
          unused: [],
          welcome_reward: 0
        }
      }
    },
    methods: {},
    created() {},
    mounted() {
    },
    components: {
        UserRewards,
        UsersList: () => import('../Index.vue'),
        RecipientsList,
        UserOrders,
        NotificationList,
        TransferLimits,
        UserInfo,
    },
}
</script>

